<script>
export default {
  inheritAttrs: false,
};
</script>

<script setup>
import { defineProps } from "vue";
import ErrorMessage from "../ErrorMessage.vue";

const { fieldLabel, modelValue, vuelidateInstance, errorClasses } = defineProps(
  {
    fieldLabel: {
      type: String,
    },
    modelValue: {},
    vuelidateInstance: {},
    errorClasses: { default: "common-error-text" },
  }
);
</script>

<template>
  <div v-bind="$attrs">
    <label class="relative inline-flex items-center cursor-pointer">
      <input
        :id="fieldLabel"
        type="checkbox"
        :name="fieldLabel"
        class="sr-only peer"
        :checked="modelValue"
        @input="$emit('update:modelValue', $event.currentTarget.checked)"
      />
      <div
        class="w-[44px] h-[28px] bg-gray-400 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-[14px] peer-checked:after:border-white after:content-[''] after:absolute after:top-[3px] after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[22px] after:w-[22px] after:transition-all dark:border-gray-600 peer-checked:bg-blue-700"
      ></div>
      <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{{
        fieldLabel
      }}</span>
    </label>
    <ErrorMessage
      :error-classes="errorClasses"
      :vuelidate-instance="vuelidateInstance"
    />
  </div>
</template>

<style scoped></style>
